import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { InfoOutlined } from "@mui/icons-material";
import { Stack } from "@/Components/v2/atoms/Stack";

const RefreshBanner = () => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.infoBanner.background,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 2,
        borderRadius: 2,
      })}
    >
      <Stack direction="row" alignItems="center">
        <Stack direction="row" spacing={1}>
          <InfoOutlined sx={(theme) => ({ color: theme.palette.infoIcon.color, fontSize: 24 })} />
          <Stack>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              Refreshing Action Plan
            </Typography>
            <Typography variant="body2">
              We&apos;re updating this Action Plan with your latest data. Please check back shortly
              for the most up-to-date and actionable insights.
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default RefreshBanner;
